<template>
  <div id="chart">
    <VueApexCharts type="donut" ref="chart" width="100%" :options="chartOptions" :series="series"></VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "ApexGradientDonutChart2",
  components: {
    VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      require: true,
    },
    colors: {
      type: Array,
      require: true,
    },
    units: {
      type: String,
      require: true,
      default: "",
    },
    label: {
      type: Array,
      require: true,
    },
    header: {
      type: String,
      require: true,
    },
    width: {
      type: Number,
      require: false,
      default: 380,
    },
    dark: {
      type: Boolean,
      require: false,
      default: false,
    },
  },

  data() {
    return {
      timer: null,

      mode: "light",
      defaultUnit: "",

      series: [],
      chartOptions: {
        tooltip: {
          enabled: true,
          y: {
            formatter: function (value) {
              return value + " " + "kW";
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },

        states: {
          hover: {
            filter: {
              type: "none",
            },
          },
        },
        chart: {
          /* width: "100%", */
          type: "donut",
          background: "transparent",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return Math.round(val) + "%";
          },
        },

        fill: {
          opacity: 0.85,
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 0.9,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 100],
            colorStops: [],
          },
        },
        legend: {
          position: "bottom",
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex] + " kW";
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.updateChart();
    this.setTheme();
  },
  methods: {
    updateChart() {
      this.series = [];

      for (let index = 0; index < this.data.length; index++) {
        if (this.data[index] < 0) {
          this.data = 0;
        }
      }
      if (this.units !== "") {
        this.defaultUnit = this.units;
      }

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          labels: this.label,
          tooltip: {
            enabled: true,
            y: {
              formatter: (y) => {
                if (typeof y !== "undefined") {
                  let formattedValue = y + " " + this.defaultUnit;
                  return formattedValue;
                }
                return y;
              },
            },
          },
          colors: this.colors,
          title: {
            align: "center",
            margin: 0,
            // text: this.header,
            style: {
              fontSize: "18px",
              fontWeight: "bold",
            },
          },
          chart: {
            /* width: "100%", */
            type: "donut",
            background: "#00000000",
          },
          legend: {
            position: "bottom",
            formatter: (val, opts) => {
              let l = val + " - " + opts.w.globals.series[opts.seriesIndex] + " " + this.defaultUnit;
              return l;
            },
          },
        },
      };

      this.series = this.data;

      // Tohle bliká :)
      /* this.$refs.chart.refresh(); */
    },

    setTheme() {
      if (this.dark === true) {
        this.mode = "dark";
        this.updateTheme();
      } else {
        this.mode = "light";
        this.updateTheme();
      }
    },
    updateTheme() {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          theme: {
            mode: this.mode,
          },
        },
      };
    },
  },
  watch: {
    data: function () {
      this.updateChart();
    },
    label: function () {
      this.updateChart();
    },
    /*     width: function () {
      this.updateChart();
    }, */
    dark: function () {
      this.setTheme();
    },
  },
};
</script>
